import React from 'react';
import { useOrg } from '../../hooks/useOrg';

/**
 * Full-screen org selection for multi-org users without a valid saved choice.
 * Props: { onSelect?: () => void }
 */
const OrgSwitcher = ({ onSelect }) => {
  const { availableOrgs, setActiveOrg, isLoading } = useOrg();

  const handlePick = async (orgId) => {
    await setActiveOrg(orgId);
    onSelect?.();
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <h2>Se încarcă...</h2>
      </div>
    );
  }

  return (
    <div
      className="app-layout"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        background: 'var(--dashboard-bg, #f4f6f8)'
      }}
    >
      <div
        style={{
          maxWidth: 520,
          width: '100%',
          background: '#fff',
          borderRadius: 12,
          padding: '2rem',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)'
        }}
      >
        <h1 style={{ margin: '0 0 1.5rem', fontSize: '1.35rem' }}>
          Selectează spitalul
        </h1>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {availableOrgs.map((org) => (
            <button
              key={org.id}
              type="button"
              onClick={() => handlePick(org.id)}
              style={{
                textAlign: 'left',
                padding: '1rem 1.25rem',
                borderRadius: 8,
                border: '1px solid #e2e8f0',
                background: '#fff',
                cursor: 'pointer',
                fontSize: '1rem'
              }}
            >
              {org.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrgSwitcher;
